import actions from './actions';

const initialState = {
  pricingLayout: false,
  activeLayout: 'pricing',
};

const {
  GET_DAILOG_STATUS_SUCCESS,
  GET_DAILOG_STATUS_ERR,
  SET_DAILOG_STATUS_SUCCESS,
  SET_DAILOG_STATUS_ERR,
  GET_ACTIVE_LAYOUT_SUCCESS,
  GET_ACTIVE_LAYOUT_ERR,
  SET_ACTIVE_LAYOUT_SUCCESS,
  SET_ACTIVE_LAYOUT_ERR,
} = actions;

const pricingLayoutDailogReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case GET_DAILOG_STATUS_SUCCESS:
      return state;
    case GET_DAILOG_STATUS_ERR:
      return err;
    case SET_DAILOG_STATUS_ERR:
      return err;
    case SET_DAILOG_STATUS_SUCCESS:
      return {
        ...state,
        pricingLayout: data,
      };
    case GET_ACTIVE_LAYOUT_SUCCESS:
      return state;
    case GET_ACTIVE_LAYOUT_ERR:
      return err;
    case SET_ACTIVE_LAYOUT_ERR:
      return err;
    case SET_ACTIVE_LAYOUT_SUCCESS:
      return {
        ...state,
        activeLayout: data,
      };
    default:
      return state;
  }
};

export { pricingLayoutDailogReducer };
